"use strict";

if (!require("./is-implemented")()) {
	Object.defineProperty(require("ext/global-this"), "Symbol", {
		value: require("./polyfill"),
		configurable: true,
		enumerable: false,
		writable: true
	});
}



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/es6-symbol/implement.js
// module id = 1491
// module chunks = 1